<div class="px-3">

  <!-- Main Content Area -->
   <div class="ms-2">
    <NavigationBackButton />
   </div>
  <div class="card-header border-0 mt-2 rounded-top-lg ms-2">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Left Side: Founder Info -->
        <div class="d-flex align-items-center">
          <i class="bx bx-user fs-4 text-dark me-2"></i>
          <div class="d-flex flex-column justify-content-center">
            <p class="fw-bold text-dark mb-0 text-x">{{ lead_name }}</p>
          </div>
        </div>

        <div class="d-flex justify-content-end align-items-center">
          <!-- Assignments -->
            <button
              class="btn btn-sm bg-transparent border-0 p-0 rounded-circle"
              @click="show_live_chat = true"
              data-bs-toggle="offcanvas" 
              data-bs-target="#offcanvasLiveChat"
            >
              <i class="bi bi-chat-right-text-fill fs-4 text-primary"></i>
            </button>
        </div>
      </div>
  </div>
  <div class="overview-application-container">
    <!-- Vertical Tabs Navigation -->
    <div class="overview-vertical-tabs-container overview-scrollable-container">
      <div 
        v-for="(tab, index) in tabs" 
        :key="index" 
        class="overview-floating-tab rounded-lg shadow-lg"
        :class="{ 'active': active_tab === tab }"
        @click="select_tab(tab)"
      >
        <div class="overview-floating-tab-inner">
          <span class="text-xs">{{ tab }}</span>
        </div>
      </div>
    </div>

    <!-- Tab Content Area -->
    <div class="overview-dropdown-column rounded-lg">
      <!-- Loading State -->
      <div v-if="is_loading && active_tab === 'Applicant Information'" class="text-center py-4">
        <div class="spinner small">Loading...</div>
      </div>

      <!-- Only show content when we have an active tab -->
      <div v-else-if="active_tab" class="overview-accordion-container mb-3 border-0 rounded-lg">
        <div class="accordion-item bg-secondary-dark">
          <h2 class="accordion-header primary-green border-0">
            <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
              <div class="position-relative flex-grow-1 me-2">
                <span class="text-xs text-bright">{{ active_tab }}</span>
              </div>
              <div class="d-flex align-items-center"> 
              </div>
            </div>
          </h2>

          <div class="collapse" :class="{ show: selected_dropdown === active_tab }">
            <div class="accordion-body">
              <!-- Show only the content for the active tab -->
              <div v-if="active_tab === 'Applicant Information'">
                <!-- Card layout exactly like Meeting Minutes tab -->
                <div class="card card-nav-tabs mt-0 rounded-lg border-0 shadow-lg">
                  <div class="card-body text-xxs">
                    <!-- Loading State -->
                    <div v-if="is_loading" class="text-center py-4">
                      <div class="spinner small">Loading...</div>
                    </div>

                    <!-- No data message -->
                    <div v-else-if="lead_responses.length === 0" class="text-center py-4">
                      <p class="text-muted">No applicant information available</p>
                    </div>

                    <!-- Form with dynamic question types -->
                    <form v-else class="px-2 py-1">
                      <div
                        v-for="response in lead_responses"
                        :key="response.id"
                        class="mb-3"
                      >
                        <div class="form-group">
                          <label class="form-label fw-bold">{{ response.question_text }}</label>

                          <!-- Text / Short text -->
                          <input v-if="['short_text', 'text'].includes(response.question_type)"
                                type="text"
                                class="form-control text-xxs bg-white"
                                :value="response.answer || 'No Answer'"
                                readonly />

                          <!-- Long text / textarea -->
                          <textarea v-else-if="['long_text', 'textarea'].includes(response.question_type)"
                                    class="form-control text-xxs bg-white"
                                    rows="3"
                                    readonly>{{ response.answer || 'No Answer' }}</textarea>

                          <!-- Number -->
                          <input v-else-if="response.question_type === 'number'"
                                type="number"
                                class="form-control text-xxs bg-white"
                                :value="response.answer || ''"
                                readonly />

                          <!-- Date -->
                          <input v-else-if="response.question_type === 'date'"
                                type="date"
                                class="form-control text-xxs bg-white"
                                :value="response.answer || ''"
                                readonly />

                          <!-- Single select / radio -->
                          <div v-else-if="['single_select', 'radio'].includes(response.question_type)" class="d-flex flex-column gap-2 mt-2">
                            <template v-if="has_options_or_answer(response)">
                              <div v-for="(option, index) in get_options_for_display(response)" :key="index" class="form-check">
                                <input class="form-check-input" type="radio" disabled
                                      :checked="is_option_selected(response.answer, option.value || option)" />
                                <label class="form-check-label text-xxs">{{ option.text || option }}</label>
                              </div>
                            </template>
                            <template v-else>
                              <input type="text"
                                    class="form-control text-xxs bg-white"
                                    :value="response.answer || 'No Answer'"
                                    readonly />
                            </template>
                          </div>

                          <!-- Multi select / checkboxes -->
                          <div v-else-if="['multi_select', 'checkbox', 'checkboxes'].includes(response.question_type)" class="d-flex flex-column gap-2 mt-2">
                            <template v-if="has_options_or_answer(response)">
                              <div v-for="(option, index) in get_options_for_display(response)" :key="index" class="form-check">
                                <input class="form-check-input" type="checkbox" disabled
                                      :checked="is_option_selected(response.answer, option.value || option)" />
                                <label class="form-check-label text-xxs">{{ option.text || option }}</label>
                              </div>
                            </template>
                            <template v-else>
                              <input type="text"
                                    class="form-control text-xxs bg-white"
                                    :value="response.answer || 'No Answer'"
                                    readonly />
                            </template>
                          </div>

                          <!-- File -->
                          <div v-else-if="response.question_type === 'file'" class="d-flex flex-column gap-2 mt-2">
                            <template v-if="response.answer && response.answer.trim() !== ''">
                              <div class="d-flex align-items-center gap-2">
                                <span class="text-xs">{{ get_file_name(response.answer) }}</span>
                                <button type="button" 
                                        class="btn btn-primary-dark btn-sm shadow-sm text-xxs"
                                        @click="open_file_preview(response.answer)">
                                  Preview
                                </button>
                              </div>
                            </template>
                            <template v-else>
                              <span class="text-muted text-xxs">No file uploaded</span>
                            </template>
                          </div>

                          <!-- Fallback -->
                          <input v-else type="text"
                                class="form-control text-xxs bg-white"
                                :value="response.answer || 'No Answer'"
                                readonly />
                        </div>
                      </div>
                    </form>

                    <!-- Action buttons (matching the style from Meeting Minutes) -->
                    <div class="modal-footer border-0 p-2 d-flex justify-content-end">
                      <button
                        class="btn btn-primary-dark btn-sm shadow-sm text-xxs me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#convert_lead_to_applicant"
                      >
                        Convert Lead to Applicant
                      </button>
                      <button
                        class="btn btn-primary-dark btn-sm shadow-sm text-xxs"
                        @click="move_to_qualified_lead"
                      >
                        Approve Lead
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else-if="active_tab === 'Meeting Minutes'">
                <UploadMeetingMinutes  :lead_id="lead_id"/>
              </div>
              <div v-else-if="active_tab === 'Share Lead Questionnaire'">
                <ShareFormsWithLead />
              </div>
              <div v-else-if="active_tab === 'Quotation'">
                <GenerateQuote />
              </div>
              <div v-else-if="active_tab === 'Invoicing'">
                <GenerateInvoice />
              </div>
              <div v-else-if="active_tab === 'Lead Tracker'">
                <LeadsLogs />
              </div>
              <div v-else-if="active_tab === 'Lead Questionnaire Form'">
                <div class="card card-nav-tabs mt-0 rounded-lg border-0 shadow-lg">
                  <div class="card-body">
                    <div v-if="loading_lead_forms" class="text-center py-4">
                      <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="text-xs text-muted mt-2">Loading questionnaire forms...</p>
                    </div>

                    <!-- Form Selection -->
                    <div v-else-if="lead_forms.length > 0" class="mb-3">
                      <label class="form-label text-xs fw-bold mb-2">Select Questionnaire Form</label>
                      <select 
                        v-model="selected_lead_form_id" 
                        class="form-select form-select-sm text-xs rounded-lg"
                      >
                        <option value="" disabled hidden>Choose a form...</option>
                        <option v-for="form in lead_forms" :key="form.lead_form_id" :value="form.lead_form_id">
                          {{ form.form_name }}
                        </option>
                      </select>
                    </div>

                    <div v-if="selected_lead_form_id && lead_forms.length > 0">
                      <QuestionnaireForm 
                        :profile_role_form_id="selected_lead_form_id" 
                        :key="selected_lead_form_id" 
                      />
                    </div>

                    <div v-else-if="!loading_lead_forms && lead_forms.length === 0" class="text-center py-4">
                      <i class="bi bi-inbox fs-1 text-muted"></i>
                      <p class="text-muted mt-2 mb-0 text-xs">
                        No questionnaire forms available for this lead
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="active_tab === 'Verification'">
              <VerificationOverview />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Show message when no tab is selected -->
      <div v-else class="text-center py-4">
        <p class="text-muted">Please select a tab to view content</p>
      </div>
    </div>
  </div>
</div>

  <AICampusFooter />
<teleport to="body">
  <div class="modal fade" id="convert_lead_to_applicant" tabindex="-1" aria-labelledby="convert_lead_to_applicant_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="convert_lead_to_applicant_label">Convert Lead To Applicant</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="convert_lead_to_applicant">
          <div class="modal-body">
            <!-- Entity type -->
            <div class="modal-form-group form-group mb-3">
              <label for="entity_type_select" class="modal-form-label form-label text-xxs">Entity type</label>
              <select
                id="entity_type_select"
                class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
                v-model="entity_type_id"
                @change="get_forms"
                :disabled="lock_entity_type"
                required
              >
                <option value="" disabled hidden>Select entity type</option>
                <option v-for="et in entity_type" :key="et.id" :value="et.id">
                  {{ et.name }}
                </option>
              </select>
            </div>

            <!-- Form -->
            <div class="modal-form-group form-group mb-3" v-if="form_list.length">
              <label for="form_select" class="modal-form-label form-label text-xxs">Form</label>
              <select
                id="form_select"
                class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
                v-model="selected_form_id"
                required
              >
                <option value="" disabled hidden>Select form</option>
                <option v-for="form in form_list" :key="form.id" :value="form.id">
                  {{ form.form_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="submit"
              class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

  <!-- Live Chat Modal -->
<teleport to="body">
  <div
    id="offcanvasLiveChat"
    class="offcanvas offcanvas-end w-50"
    tabindex="-1"
    @click.self="show_live_chat = false"
  >
        <!-- Header -->
        <div class="offcanvas-header cute-header border-bottom-0">
          <h5 class="text-white text-x">Chat with Lead</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <!-- Body -->
        <div class="offcanvas-body">
          <LiveChat />
        </div>
      </div>
</teleport>
